module.exports = __webpack_public_path__ + "officialStatic/img/tdm.041cbeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/tdm.png
// module id = EzwY
// module chunks = 0